import { css } from '@emotion/core';
import { media, globalTokens, variables } from '@domain-group/fe-brary';
var colors = globalTokens.colors;
var _ref = {
  name: "ny87qu",
  styles: "height:194px;"
};
var _ref2 = {
  name: "1n3v4hx",
  styles: "width:260px;height:174px;"
};
export var image = _ref5 => {
  var _ref5$isDefault = _ref5.isDefault,
    isDefault = _ref5$isDefault === void 0 ? false : _ref5$isDefault,
    _ref5$appearance = _ref5.appearance,
    appearance = _ref5$appearance === void 0 ? 'horizontal' : _ref5$appearance;
  return /*#__PURE__*/css("display:block;position:relative;width:100%;max-width:100%;text-align:center;text-decoration:none;float:left;", isDefault && /*#__PURE__*/css("background-color:", colors.neutralGrey100, ";color:", colors.neutralGrey500, ";height:174px;"), " ", appearance === 'vertical' && _ref, " ", appearance === 'horizontal' && _ref2);
};
var _ref3 = {
  name: "ox4bgy",
  styles: "padding-top:58px;"
};
var _ref4 = {
  name: "10klw3m",
  styles: "height:100%;"
};
export var imgWide = _ref6 => {
  var _ref6$isDefault = _ref6.isDefault,
    isDefault = _ref6$isDefault === void 0 ? false : _ref6$isDefault,
    _ref6$isVerticalCard = _ref6.isVerticalCard,
    isVerticalCard = _ref6$isVerticalCard === void 0 ? false : _ref6$isVerticalCard;
  return /*#__PURE__*/css("width:100%;", isDefault ? _ref3 : /*#__PURE__*/css("height:194px;object-fit:cover;background-color:", colors.neutralGrey050, ";", isVerticalCard && _ref4));
};
export var imgSquare = isDefault => /*#__PURE__*/css("display:inline-block;width:100%;", isDefault ? /*#__PURE__*/css(media('>=tablet'), "{width:100%;margin-top:20%;}") : /*#__PURE__*/css("height:100%;object-fit:cover;background-color:", colors.neutralGrey050, ";"));
export var watchlistButton = /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:center;align-items:center;gap:10px;position:absolute;width:48px;height:40px;border-radius:3px;right:0;z-index:", variables.global.layerOverlay, ";");